/* DADDY sound: a steamy men's bathhouse.
   Recorded (CC0, see README): men's groans (assets/audio/moan-1..4.mp3), sauna steam and dripping water loops.
   Synthesized: tiled-room echo and low room tone; synthesized moans are only a fallback if recordings fail to load.
   Off until the visitor turns it on (browsers need a tap first). */
(function () {
  var ctx = null, master = null, wet = null, dry = null, on = false, loops = [];
  var btn = document.getElementById("soundToggle");
  var rnd = function (a, b) { return a + Math.random() * (b - a); };
  /* Phones: small speakers lose the low, muffled voices under the steam, so voices are mixed louder and clearer there. */
  var PHONE = (window.matchMedia && matchMedia("(pointer:coarse)").matches) || window.innerWidth < 750;
  var MIX = PHONE ? { steam: .28, drips: .22, near: [.95, 1.2], far: [.7, .9], farCut: 2800, farChance: .3 }
                  : { steam: .55, drips: .35, near: [.6, .85], far: [.35, .55], farCut: 1500, farChance: .55 };
  var unlockEl = null;
  function unlockPhoneAudio() {            // iPhone: let sound play even with the ring/silent switch on silent
    try { if (navigator.audioSession) navigator.audioSession.type = "playback"; } catch (e) {}
    if (!unlockEl) {
      var sr = 8000, n = sr / 2, b = new ArrayBuffer(44 + n * 2), v = new DataView(b), s = function (o, t) { for (var i = 0; i < t.length; i++) v.setUint8(o + i, t.charCodeAt(i)); };
      s(0, "RIFF"); v.setUint32(4, 36 + n * 2, true); s(8, "WAVEfmt "); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
      v.setUint32(24, sr, true); v.setUint32(28, sr * 2, true); v.setUint16(32, 2, true); v.setUint16(34, 16, true); s(36, "data"); v.setUint32(40, n * 2, true);
      unlockEl = new Audio(URL.createObjectURL(new Blob([b], { type: "audio/wav" })));
      unlockEl.loop = true; unlockEl.setAttribute("playsinline", ""); unlockEl.preload = "auto";
    }
    var p = unlockEl.play(); if (p && p.catch) p.catch(function () {});
  }

  function noiseBuffer(sec) {
    var len = ctx.sampleRate * sec, buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    return buf;
  }
  function tileVerb(sec) {                 // bright, long echo of a tiled steam room
    var len = ctx.sampleRate * sec, buf = ctx.createBuffer(2, len, ctx.sampleRate);
    for (var c = 0; c < 2; c++) {
      var d = buf.getChannelData(c);
      for (var i = 0; i < len; i++) { var t = i / len; d[i] = (Math.random() * 2 - 1) * Math.pow(1 - t, 2.6) * (i < 600 ? i / 600 : 1); }
    }
    var cv = ctx.createConvolver(); cv.buffer = buf; return cv;
  }

  function ensure() {
    if (ctx) return;
    var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
    ctx = new AC();
    master = ctx.createGain(); master.gain.value = 0;
    var comp = ctx.createDynamicsCompressor(); comp.threshold.value = -20; comp.knee.value = 12; comp.ratio.value = 4; comp.attack.value = .005; comp.release.value = .25;
    var out = ctx.createGain(); out.gain.value = PHONE ? 1.6 : 1.15;
    master.connect(comp); comp.connect(out); out.connect(ctx.destination);
    var verb = tileVerb(2.8); wet = ctx.createGain(); wet.gain.value = 0.55; verb.connect(wet); wet.connect(master);
    dry = ctx.createGain(); dry.gain.value = 0.5; dry.connect(master);
    dry.connect(verb);
    var nb = noiseBuffer(3);

    loadRecordings();
    // room tone: low rumble of pipes and far-off voices
    var room = ctx.createBufferSource(); room.buffer = nb; room.loop = true; room.playbackRate.value = 0.5;
    var lp = ctx.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 320;
    var rg = ctx.createGain(); rg.gain.value = 0.09; room.connect(lp); lp.connect(rg); rg.connect(dry); room.start();

    loops.push(setInterval(function () { if (live() && !REC.drips) drip(); }, 900));     // synth drips until the recording loads
    loops.push(setInterval(function () { if (live() && Math.random() < .35) hissBurst(nb); }, 5000));
    schedMoan();
  }
  function live() { return on && ctx && !document.hidden; }

  function drip() {
    if (Math.random() < .45) return;
    var t = ctx.currentTime, o = ctx.createOscillator(), g = ctx.createGain(), p = ctx.createStereoPanner ? ctx.createStereoPanner() : ctx.createGain();
    var f = rnd(900, 1700); o.type = "sine"; o.frequency.setValueAtTime(f, t); o.frequency.exponentialRampToValueAtTime(f * .35, t + .05);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(rnd(.04, .09), t + .004); g.gain.exponentialRampToValueAtTime(0.0001, t + .09);
    if (p.pan) p.pan.value = rnd(-.8, .8);
    o.connect(g); g.connect(p); p.connect(wet.context === ctx ? dry : dry); o.start(t); o.stop(t + .12);
  }
  function hissBurst(nb) {                 // someone opens the steam valve
    var t = ctx.currentTime, s = ctx.createBufferSource(), f = ctx.createBiquadFilter(), g = ctx.createGain();
    s.buffer = nb; f.type = "highpass"; f.frequency.value = 2500;
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(.07, t + .6); g.gain.exponentialRampToValueAtTime(0.0001, t + 3.2);
    s.connect(f); f.connect(g); g.connect(dry); s.start(t); s.stop(t + 3.4);
  }

  var REC = { moans: [], steam: null, drips: null }, base = (document.currentScript && document.currentScript.src) || location.href;
  function load(name) {
    return fetch(new URL("daddy-" + name, base)).then(function (r) { if (!r.ok) throw 0; return r.arrayBuffer(); })
      .then(function (ab) { return new Promise(function (res, rej) { ctx.decodeAudioData(ab, res, rej); }); });
  }
  function loopBed(buf, vol, toWet) {
    var src = ctx.createBufferSource(), g = ctx.createGain(); src.buffer = buf; src.loop = true;
    g.gain.value = vol; src.connect(g); g.connect(toWet ? wet : dry); if (toWet) g.connect(dry); src.start(0, Math.random() * buf.duration);
  }
  function loadRecordings() {
    load("steam-loop.mp3").then(function (b) { REC.steam = b; loopBed(b, MIX.steam, false); }).catch(function () {});
    load("drips-loop.mp3").then(function (b) { REC.drips = b; loopBed(b, MIX.drips, true); }).catch(function () {});
    [1, 2, 3, 4].forEach(function (n) { load("moan-" + n + ".mp3").then(function (b) { REC.moans.push(b); }).catch(function () {}); });
  }
  function recMoan(delay, far) {                       // a few seconds from one of the men's recordings, placed somewhere in the steam room
    var b = REC.moans[(Math.random() * REC.moans.length) | 0], len = Math.min(b.duration, rnd(2.5, 6));
    var off = Math.random() * Math.max(0, b.duration - len), t = ctx.currentTime + (delay || 0);
    var src = ctx.createBufferSource(), g = ctx.createGain(); src.buffer = b; src.playbackRate.value = rnd(.94, 1.02);
    var vol = far ? rnd(MIX.far[0], MIX.far[1]) : rnd(MIX.near[0], MIX.near[1]);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol, t + .35);
    g.gain.setValueAtTime(vol, t + len - .6); g.gain.exponentialRampToValueAtTime(0.0001, t + len);
    var pan = ctx.createStereoPanner ? ctx.createStereoPanner() : ctx.createGain(); if (pan.pan) pan.pan.value = rnd(-.8, .8);
    src.connect(g); g.connect(pan);
    if (far) { var muf = ctx.createBiquadFilter(); muf.type = "lowpass"; muf.frequency.value = MIX.farCut; pan.connect(muf); muf.connect(wet); if (PHONE) muf.connect(dry); }
    else { pan.connect(dry); }
    src.start(t, off, len + .05);
  }

  // fallback synthesized moans: a low voiced buzz shaped by vowel formants ("mmm", "ohh", "ahh"), breath on top, pitch rising then falling
  var VOWELS = { mm: [[280, 4, 1], [900, 6, .15], [2200, 8, .05]], oh: [[480, 5, 1], [820, 6, .5], [2500, 9, .12]], ah: [[700, 5, 1], [1150, 6, .55], [2450, 9, .15]], uh: [[560, 5, 1], [1050, 6, .45], [2400, 9, .1]] };
  function moan(delay, far) {
    if (REC.moans.length) return recMoan(delay, far);
    var t = ctx.currentTime + (delay || 0), dur = rnd(1.1, 2.6), f0 = rnd(82, 128);
    var kinds = Object.keys(VOWELS), v = VOWELS[kinds[(Math.random() * kinds.length) | 0]];
    var src = ctx.createOscillator(); src.type = "sawtooth";
    src.frequency.setValueAtTime(f0 * .92, t);
    src.frequency.linearRampToValueAtTime(f0 * rnd(1.08, 1.3), t + dur * rnd(.25, .45));
    src.frequency.linearRampToValueAtTime(f0 * rnd(.72, .86), t + dur);
    var vib = ctx.createOscillator(), vg = ctx.createGain(); vib.frequency.value = rnd(4.5, 6); vg.gain.value = f0 * .025; vib.connect(vg); vg.connect(src.frequency);
    var pre = ctx.createBiquadFilter(); pre.type = "lowpass"; pre.frequency.value = 3200;  // soften the buzz
    src.connect(pre);
    var env = ctx.createGain(), peak = (far ? .1 : .2) * rnd(.7, 1);
    env.gain.setValueAtTime(0.0001, t);
    env.gain.exponentialRampToValueAtTime(peak, t + dur * .3);
    env.gain.setTargetAtTime(peak * .7, t + dur * .45, .2);
    env.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    v.forEach(function (fm) {
      var b = ctx.createBiquadFilter(); b.type = "bandpass"; b.frequency.value = fm[0] * rnd(.95, 1.05); b.Q.value = fm[1];
      var bg = ctx.createGain(); bg.gain.value = fm[2] * 2.2; pre.connect(b); b.connect(bg); bg.connect(env);
    });
    // breath
    var br = ctx.createBufferSource(); br.buffer = noiseBuffer(dur + .2);
    var bf = ctx.createBiquadFilter(); bf.type = "bandpass"; bf.frequency.value = 1400; bf.Q.value = .8;
    var bgn = ctx.createGain(); bgn.gain.value = .25; br.connect(bf); bf.connect(bgn); bgn.connect(env);
    var pan = ctx.createStereoPanner ? ctx.createStereoPanner() : ctx.createGain(); if (pan.pan) pan.pan.value = rnd(-.85, .85);
    env.connect(pan);
    if (far) { var muf = ctx.createBiquadFilter(); muf.type = "lowpass"; muf.frequency.value = 1100; pan.connect(muf); muf.connect(wet); }
    else pan.connect(dry);
    [src, vib, br].forEach(function (n) { n.start(t); n.stop(t + dur + .1); });
  }
  function schedMoan() {
    setTimeout(function () {
      if (live()) {
        var far = Math.random() < MIX.farChance; moan(0, far);
        if (Math.random() < .3) moan(rnd(.4, 1.4), !far);          // a second man answers
        if (Math.random() < .2) moan(rnd(1.8, 2.8), far);
      }
      schedMoan();
    }, PHONE ? rnd(3000, 7000) : rnd(4000, 10000));
  }

  function blip(freq, dur, vol, type) {
    if (!on || !ctx) return;
    var t = ctx.currentTime, o = ctx.createOscillator(), g = ctx.createGain();
    o.type = type || "square"; o.frequency.setValueAtTime(freq, t);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol, t + 0.004); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(master); o.start(t); o.stop(t + dur + 0.02);
  }
  var tickN = 0;
  var api = {
    tick: function () { if (++tickN % 3 === 0) blip(1900 + Math.random() * 600, .018, .02, "square"); },  // faint terminal chirp
    line: function () {},
    press: function () { blip(1320, .05, .04, "square"); setTimeout(function () { blip(880, .07, .035, "square"); }, 70); },
    alert: function () { if (ctx && on) moan(0, false); }                                                  // a suggestion earns a moan
  };
  window.MotherSound = api;
  function set(v) {
    on = v;
    if (btn) { btn.setAttribute("aria-pressed", v ? "true" : "false"); btn.textContent = v ? "SOUND ON" : "SOUND OFF"; }
    if (v) { unlockPhoneAudio(); ensure(); if (!ctx) return; ctx.resume(); master.gain.setTargetAtTime(0.8, ctx.currentTime, 0.5); var tries = 0; (function first() { if (!on) return; if (REC.moans.length || ++tries > 20) moan(0, false); else setTimeout(first, 250); })(); }
    else { if (ctx) master.gain.setTargetAtTime(0, ctx.currentTime, 0.1); if (unlockEl) unlockEl.pause(); }
  }
  if (btn) btn.addEventListener("click", function () { set(!on); });
  document.addEventListener("visibilitychange", function () { if (!document.hidden && on && ctx) { ctx.resume(); if (unlockEl) { var p = unlockEl.play(); if (p && p.catch) p.catch(function () {}); } } });
})();
